export default {"src":"/_next/static/media/circlePersonSparkleLight_64.e2da0b87.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};